import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { useMobxStore } from 'store/mobx';
import { HCaptchaFooter } from './HCaptchaFooter';

interface IFooterProps {
  isHCaptchaPage?: boolean;
  showFooterText: boolean;
}

const Footer = (props: IFooterProps) => {
  const { accountStore } = useMobxStore();
  const { i18n } = useTranslation();
  const { generalSettings } = accountStore;

  const { isHCaptchaPage, showFooterText } = props;
  const { language } = i18n;

  const trademark = generalSettings.trademarkParams[language];
  const currentYear = new Date().getFullYear();

  if (!trademark) {
    return null;
  }

  //@ts-ignore
  const copyrightTranslation: string = i18n.t(trademark.copyright, { year: currentYear });

  return (
    <footer className="footer">
      <div className="container">
        {showFooterText && (
          <>
            <div className="footer__text" dangerouslySetInnerHTML={{ __html: trademark.footer }} />
            {isHCaptchaPage && <HCaptchaFooter />}
          </>
        )}
        <div className="footer__cr">{copyrightTranslation}</div>
      </div>
    </footer>
  );
};

export default observer(Footer);
